module.exports = __webpack_public_path__ + "img/email-confirmation-success.e44977ff.svg";